import React, { useEffect } from 'react';
import { MenuBox, MenuWrapper } from './Menu.style';
import { Modal } from 'reactstrap';

const Menu = ({
  handleVisibleMenu,
  visible,
  disableBackgroundScroll,
  backgroundColor,
  direction,
  width,
  children,
}) => {
  useEffect(() => {
    document.body.style.overflow = disableBackgroundScroll && 'hidden';

    return () => {
      document.body.style.overflow = 'auto';
    };
  });

  return (
    <React.Fragment>
      <Modal isOpen={visible}>
        <MenuBox
          visible={true}
          backgroundColor={backgroundColor}
          direction={direction}
          width={width}
          data-id="menu-box"
        >
          <MenuWrapper>{children}</MenuWrapper>
        </MenuBox>
      </Modal>
    </React.Fragment>
  );
};

export default Menu;
